define([ // START Open Requre.JS wrapper
	'jquery',
    'wcs.context',
    'wcs.alert',
    'domReady',
    'pubsub',
    'promise!wcs.lang-msg'
	], function($, ctx, alert, domReady) {

	'use strict';

    var storeId = ctx.getStoreId(),
        cookieNames = [],
        employeeSpendMsgPersistEnabled = WCS_CONFIG.get('MY_ACCOUNT::myAccountEmployeeSpendMsgPersistEnabled');

	 	cookieNames.push("EMPLOYEEDISCOUNTCAP"+storeId, "EMPLOYEEDISCOUNTSPEND"+storeId, "EMPLOYEELOGONLANDING"+storeId);

           function getCookies(cookieNames) {
                return cookieNames.map(function(name){
                var cookie = ctx.getCookie(name);
                var newCookie =  cookie ? JSON.parse(cookie): false;
                if(newCookie) {
                    newCookie.name = name;
                }
                return newCookie;
               });
           }

           function checkNotificationContainer(){
               // Generate the notification container if it does not exist on the current page
               var $pageNotification = $('.page-notification-js');

        	    if ($pageNotification.length == 0) {

                    var containerSelector = null,
                        possibleContainerSelectors = ['#product-detail', '.page-meta', '.page-contents', 'body > div'];

                        for(var i = 0; i < possibleContainerSelectors.length; i++){
                        var selector = possibleContainerSelectors[i];
                        if ($(selector).length > 0) {
                            containerSelector = selector;
                            break;
                        }
                    }

                    // Inject page notification/messaging elements
                    $(containerSelector).first().prepend('<div class="page-notification text-center page-notification-js"><section class="page-messaging-js"></section></div>');

                    // Show container if hidden
                    if($(containerSelector).css('display') == 'none') {
                        $(containerSelector).css({'display': 'block', 'padding': '0 0 20px 0'});
                    }
                } else {
                    $pageNotification.addClass('text-center').css('padding','0 0 20px 0');
                }
           }

           function removeCookies(cookies) {
               cookies.forEach(function(cookie) {
                    if(cookie) {
                            ctx.removeCookie(cookie.name);
                    }
                });
           }

           function insertNotification(messageText, notificationType) {
               var existingMessage = $('.page-messaging-js:not(.hide)').find('.message').length,
                   employeeCapMessage = $('.page-messaging-js:not(.hide)').find('.message.error.employee-discount-message').length,
                   msgStyle = 'margin: 0 0 20px 0';

                // No messages on page, display message
                if(!existingMessage) {
                    alert.showPageNotification(messageText, notificationType, {
                        escapeHtml: false
                    });

                    $('.message.error').addClass('employee-discount-message');
                //Message already on page, add on to existing message and target first div only in message container
                } else {
                    if(employeeCapMessage) {
                        msgStyle = '';
                    }
                    $('.page-messaging-js div').first().prepend("<p role='alert' aria-live='assertive' class='employee-discount-message message "+notificationType+"' style='"+msgStyle+"'>"+messageText+"</p>");
                }
           }

           function displayMessage(cookies) {
               var messageText;

               checkNotificationContainer();

               cookies.forEach(function(cookie){
                   if(cookie.errorMessageKey) {
                    messageText = $('<div />').html(LANG_MSG[cookie.errorMessageKey]).text();

                    insertNotification(messageText, 'error');

                   } else if(cookie.messageKey){
                    messageText = $('<div />').html(LANG_MSG[cookie.messageKey]).text();
                    var spentAmount = (cookie.adjustAmount === cookie.adjustCap) ? Number(parseFloat(cookie.adjustAmount)).toLocaleString('en') : Number(parseFloat(cookie.adjustAmount)).toLocaleString('en', { minimumFractionDigits: 2}),
                        totalCap = Number(parseFloat(cookie.adjustCap)).toLocaleString('en'),
                        brandName = cookie.brandName.replace(/\+/g,' '),
                        notificationType = (cookie.adjustAmount === cookie.adjustCap) ? 'error' : 'success';

                        //Replace placeholder variables in messageText
                        messageText = messageText.replace('{0}', spentAmount)
                                                 .replace('{1}',totalCap)
                                                 .replace('{2}', brandName);

                        insertNotification(messageText, notificationType);
                   }
               });
           }

           function initEmployeeDiscountMessage() {
                    var cookieSheet = getCookies(cookieNames),
                    currentPageName = dataLayer[0].pageName;

                if(cookieSheet[0] || cookieSheet[1]) {
                    if(employeeSpendMsgPersistEnabled) {
                        // Display persistent Employee Spend messages on Shopping Cart or one-time messages on Logon ECOM Landing page
                        if(currentPageName === 'shopcart' ||  cookieSheet[2]) {
                            // Display Employee Discount Messages
                            displayMessage(cookieSheet);
                        }

                        // Remove Employee Discount Cap and Logon Landing Cookie
                        ctx.removeCookie(cookieSheet[0].name);
                        ctx.removeCookie(cookieSheet[2].name);
                    } else {
                        // Display one-time messages on Logon ECOM Landing page
                        displayMessage(cookieSheet);

                        // Remove All Employee Discount Cookies
                        removeCookies(cookieSheet);
                    }
                }
           }

    domReady(function() {
       initEmployeeDiscountMessage();

        // If on Shopcart, add listener to pick up changes to cart
       if(dataLayer[0].pageName === 'shopcart') {
           $.pubsub('subscribe', 'SHOPCART_UPDATED', function (event, data) {
                // Reinit Employee discount message
                initEmployeeDiscountMessage();
            });
        }
    });
});
